var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fadeDelay = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = require("styled-components");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    0%,\n    39%,\n    100% {\n        opacity: 0;    \n    }\n    40% {\n        opacity: 1;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var fadeDelay = (0, _styledComponents.keyframes)(_templateObject());
exports.fadeDelay = fadeDelay;